import { render, staticRenderFns } from "./ExamInfoPage.vue?vue&type=template&id=6da265dc&scoped=true"
import script from "./ExamInfoPage.vue?vue&type=script&lang=js"
export * from "./ExamInfoPage.vue?vue&type=script&lang=js"
import style0 from "./ExamInfoPage.vue?vue&type=style&index=0&id=6da265dc&prod&lang=css"
import style1 from "./ExamInfoPage.vue?vue&type=style&index=1&id=6da265dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da265dc",
  null
  
)

export default component.exports